import React from 'react';
import "./Pages.css"
const resume = () => {
    return (
       <div>
          <main className="body">
            <h1 className="header">ROHIT NARAYANAN</h1>
            <h2 className="subheader">Engineer. Programmer. Adventurer.</h2>
            <p className="text1">
             At a young age, computers have always been quite fascinating for me. That is why
             I am fortunate to be able to pursue a degree in Computer Engineering

            at the University of Illinois at Urbana-Champaign. Being able to enhance my knowledge in 
            programming while learning how the computer breaks it down
      
            helps paint an idea in my head of how to help innovate the future.
            <br></br>
            <br></br>
            When I am not grinding out a project or studying for classes, you can catch me expressing my
            competitive nature in the sport of volleyball or in video games. 
          
            I consider myself an outdoorsman, given that I always try to take advantage of nice days
            to go on bike rides, play sports, or go driving. Having already stepped foot on 16 
           
            different countries and being voted most likely to travel the world in my high school yearbook,
            it is my life's goal to explore new places.
            <br></br>
            <br></br>
            I am currently looking to pursue a software engineering internship during the Summer of 2021.
            If you are here looking to potentially offer said internship, I highly encourage you to take
            a look at the other pages to on this website to get to know me better!
            </p>
            </main>
       </div>
    );
}
 
export default resume;